<template>
  <app-card-link-background
    class="group h-full"
    :target="target"
    :to="{ name: 'blog-slug', params: { slug: post.slug } }"
  >
    <section :class="{ 'rounded border': outlined }">
      <div
        class="mb-4 aspect-[2] overflow-hidden rounded-lg"
        :class="{ 'rounded-b-none': outlined }"
      >
        <app-image
          v-if="post.og_image"
          alt=""
          class="object-cover transition duration-500 group-hover:scale-105"
          :src="post.og_image"
          :width="800"
        />
      </div>

      <div :class="{ 'px-3 pb-3': outlined, 'px-2': !outlined }">
        <component :is="titleLevel" class="line-clamp-3 font-semibold">
          {{ post.title }}
        </component>
      </div>
    </section>
  </app-card-link-background>
</template>

<script lang="ts" setup>
import type { BlogPostPage } from "~~/model/blog.model";

withDefaults(
  defineProps<{
    post: BlogPostPage;
    target?: "_blank";
    titleLevel?: `h${2 | 3 | 4 | 5 | 6}` | "p";
    outlined?: boolean;
  }>(),
  {
    target: undefined,
    titleLevel: "h3",
  },
);
</script>
